import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// components
import DataTable from "./dataTable";
import CopyMustVistForm from "./copyMustVistForm";

// mui
import { Card, Box, Typography, makeStyles } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
    detailsCard: {
        padding: theme.spacing(2),
        width: "100%",
        boxShadow: "none",
    },
    applyFilters: {
        textAlign: "right",
    },
}));

export default function ParticipatingUniversitiesTab({
    participatingUniversities,
    registrantCode,
    firstName,
    lastName,
    allNotes,
}) {
    const classes = useStyles();
    const universityDetails = useSelector(
        (state) => state.universityDetails.data
    );
    const [loadAllMustVistCell, setLoadAllMustVistCell] = useState(false);
    return (
        <Card className={classes.detailsCard}>
            {participatingUniversities && participatingUniversities.length > 0 && (
                <>
                    <Box mt={0.5} mb={1.5}>
                        <Typography variant="h4">Participating Universities</Typography>
                    </Box>
                    {universityDetails.showPU && (
                        <Box mt={0.5} mb={1.5}>
                            <CopyMustVistForm
                                loadAllMustVistCell={loadAllMustVistCell}
                                setLoadAllMustVistCell={setLoadAllMustVistCell}
                                registrantCode={registrantCode}
                                rows={participatingUniversities}
                            />
                        </Box>
                    )}
                    <DataTable
                        loadAllMustVistCell={loadAllMustVistCell}
                        rows={participatingUniversities}
                        registrantCode={registrantCode}
                        firstName={firstName}
                        lastName={lastName}
                        allNotes={allNotes}
                    />
                </>
            )}
        </Card>
    );
}

ParticipatingUniversitiesTab.propTypes = {
    participatingUniversities: PropTypes.array.isRequired,
    registrantCode: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    allNotes: PropTypes.array,
};
